import { DateTime } from '@ksyos/date-time';
import type { IRequest } from '../../common/interfaces/IRequest';
import { ServiceCode } from '../../common/enums/ServiceCode';

export function getLastOsasRequestWithMraReferralLetter(requests?: IRequest[]) {
    return requests?.find(
        (request) =>
            [ServiceCode.OSASC2, ServiceCode.OSASVC].includes(request.service.code as ServiceCode) &&
            request.customControlData?.mraReferralLetter &&
            request.dateSent &&
            DateTime.from(request.dateSent).isAfter(DateTime.now().subtract(1, 'year'))
    );
}
